import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';

import { Title, Key, Value, Button, Space } from './styles';

const propTypes = {
  currentCase: PropTypes.object.isRequired,
  hasPrevCase: PropTypes.bool.isRequired,
  openPrevCase: PropTypes.func.isRequired,
};

const headerSize = 4;
const bodySize = 8;

const ViewerInfo = ({ currentCase, hasPrevCase, openPrevCase }) => {
  return (
    <Fragment>
      <Grid container justifyContent="space-between" sx={{ margin: 2 }}>
        <Grid size={12}>
          <Title>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_case_info'
            )}
          </Title>
        </Grid>
        {/* Case ID */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_case_id'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value>{currentCase.caseIdentifierId}</Value>
        </Grid>
        {/* Prev Case ID */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_prev_case_id'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-case-id">
            {hasPrevCase
              ? currentCase.prevCase.caseIdentifierId
              : intl.get(
                  'dashboard_received_assignment_kenshin_viewer_info_text_prev_case_id_none'
                )}
          </Value>
          {hasPrevCase && (
            <>
              <Space />
              <Button onClick={openPrevCase}>
                {intl.get(
                  'dashboard_received_assignment_kenshin_viewer_info_button_open_prev_case'
                )}
              </Button>
            </>
          )}
        </Grid>
        {/* Patient ID */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_patient_id'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-patient-id">{currentCase.patientId}</Value>
        </Grid>
        {/* Study ID */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_study_id'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-study-id">
            {currentCase.studyInstanceUID}
          </Value>
        </Grid>
        {/* Patient Name */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_patient_name'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-patient-name">
            {currentCase.patientName}
          </Value>
        </Grid>
        {/* From */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_from'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-from">{currentCase.srcOrgName}</Value>
        </Grid>
        {/* Patient Gender */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_patient_gender'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-patient-gender">
            {currentCase.patientGender}
          </Value>
        </Grid>
        {/* Patient Age */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_patient_age'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-patient-age">
            {currentCase.patientAge}
          </Value>
        </Grid>
        {/* Body Part */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_bodypart'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-body-part">{currentCase.bodypart}</Value>
        </Grid>
        {/* Modality */}
        <Grid size={headerSize}>
          <Key>
            {intl.get(
              'dashboard_received_assignment_kenshin_viewer_info_text_modality'
            )}
          </Key>
        </Grid>
        <Grid size={bodySize}>
          <Value data-testid="viewer-modality">{currentCase.modality}</Value>
        </Grid>
      </Grid>
    </Fragment>
  );
};

ViewerInfo.propTypes = propTypes;

export default ViewerInfo;
